module.exports = __webpack_public_path__ + "img/pentagon-check-green.d91553b0.svg";